import { useEffect, useState } from 'react'

import { SelectChangeEvent } from '@mui/material/Select'
import { Card } from 'components'
import { useLoading, useModal, useToggle } from 'hooks'
import { useAuth } from 'hooks'
import useApp from 'hooks/useApp'
import moment from 'moment'
import { GenerateCreServices, ICriarSimulacao } from 'services/NGT/GenerateCre'
import { SPACING } from 'utils'

import { ViewContractModal } from '../ViewContractModal/ViewContractModal'
import { GenerateCreForm, TableGenerateCre } from './components'

interface ICreateSimulationParams {
  posGerarCarteira?: boolean
  simulacao?: string
  limparLista?: boolean
  paginacao?: boolean
  psqsGeral?: boolean
  isClear?: Boolean
}

const GenerateCre: React.FC = () => {
  const { user } = useAuth()
  const { setLoading, setMsgErro } = useLoading()
  const { setTitlePage } = useApp()

  const { showModal } = useModal()
  const [openViewContractModal, toggleViewContractModal] = useToggle()
  const [selectedContractId, setSelectedContractId] = useState(0)
  const [page, setPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)
  const [totalItems, setTotalItems] = useState<number>(0)
  const [ordenacaoList, setOrdenacaoList] = useState<string[]>([])
  const [creTableData, setCreTableData] = useState<any[]>([])
  const [qtdCarteiraItens, setQtdCarteiraItens] = useState('')
  const [qtdOldCarteiraItens, setOldQtdCarteiraItens] = useState('0')
  const [pesquisaGeral, setPesquisaGeral] = useState<string | null>('')
  const [ordemPrioridades, setOrdemPrioridades] = useState<string[]>([])
  const [competenciaConsolidada, setCompetenciaConsolidada] = useState<boolean>(false);
  const [contractsIncluded, setContractsIncluded] = useState<any[]>([])
  const [, setContractsExcluded] = useState<number[]>([])
  const [nuPrimeiraMobilizacao, setNuPrimeiraMobilizacao] = useState(null)
  const [nuUltimaMedicao, setNuUltimaMedicao] = useState(null)
  const [nuDenuncia, setNuDenuncia] = useState(null)
  const [nuProjeto, setNuProjeto] = useState(null)
  const [nuAlerta, setNuAlerta] = useState(null)
  const [nuUltimaAnalise, setNuUltimaAnalise] = useState(null)
  const [nuValorFolha, setNuValorFolha] = useState(null)
  const [nuQtEfetivo, setNuQtEfetivo] = useState(null)
  const [existingWallet, setExistingWallet] = useState('')
  const [limpar, setLimpar] = useState<boolean>(false)
  const [itensCheckados, setItensCheckados] = useState<string[]>([])
  const [oldRequestQuery, setOldRequestQuery] = useState({})
  const [unCheckAll, setUncheckAll] = useState(false)
  const [checkAll, setCheckAll] = useState(false)
  const [clearCheckAll, setClearCheckAll] = useState(false)

  const handleViewContractModal = (contractId: number) => {
    setSelectedContractId(contractId)
    toggleViewContractModal()
  }

  const handleChangeQtdCarteira = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQtdCarteiraItens(e.target.value)
  }

  const handleChangePesqisaGeral = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPesquisaGeral(e.target.value)
  }

  const handleChangeOrdemPrioridades = (
    event: SelectChangeEvent<typeof ordemPrioridades>
  ) => {
    const {
      target: { value }
    } = event
    setOrdemPrioridades(typeof value === 'string' ? value.split(',') : value)
  }

  const handleClearButton = () => {
    setQtdCarteiraItens('')
    setClearCheckAll(true)
    setNuPrimeiraMobilizacao(null)
    setNuUltimaMedicao(null)
    setNuDenuncia(null)
    setNuProjeto(null)
    setNuAlerta(null)
    setNuUltimaAnalise(null)
    setNuValorFolha(null)
    setNuQtEfetivo(null)
    setOrdemPrioridades([])
    setContractsIncluded([])
    setContractsExcluded([])
    setPesquisaGeral('')
    setLimpar(true)
  }

  const handleContractSelection = (contract, index, unChecks, idsToExclude) => {
    if (creTableData[index].checked) {
      creTableData[index].checked = false
      setItensCheckados(
        [...itensCheckados.filter((included) => included !== contract)].filter(
          (i) => i
        )
      )
    } else {
      creTableData[index].checked = true
      setItensCheckados((e) =>
        [...e, creTableData[index].movimentacaoId].filter((i) => i)
      )
    }
    setCreTableData([...creTableData])
  }

  useEffect(() => {
    setTitlePage(
      `CARTEIRA - ${competenciaConsolidada ? moment().subtract(1, 'months').format('MM/yyyy') : moment().subtract(2, 'months').format('MM/yyyy')}`
    )
  }, [competenciaConsolidada])

  useEffect(() => {
    if (contractsIncluded.length > +qtdCarteiraItens) {
      setQtdCarteiraItens(contractsIncluded.length.toString())
    }
  }, [contractsIncluded])

  const removeTitle = () => setTitlePage(null)

  useEffect(() => {
    window.addEventListener('onbeforeunload', removeTitle)

    return () => {
      removeTitle()
      window.removeEventListener('onbeforeunload', removeTitle)
    }
  }, [])

  const handleIncludeCre = async () => {
    setLoading('loading')
    const carteiraItensInclude = itensCheckados.map((item) => ({
      idMovimentacao: item,
      idUsuario: user.IdUsuario
    }))

    await GenerateCreServices()
      .includeCarteira(carteiraItensInclude)
      .then((response) => {
        if (response.status !== 200 || !response.data.sucesso) {
          throw new Error(response.data.mensagem)
        }

        setQtdCarteiraItens('')
        setOldQtdCarteiraItens('')
        handleCreateSimulation({
          posGerarCarteira: true,
          simulacao: 'simulacao'
        })

        showModal({
          hideButtonCancel: true,
          message: 'Carteira foi incluida com sucesso!',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')

        showModal({
          hideButtonCancel: true,
          message: error.message ?? 'Erro ao incluir carteira',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
      })
  }

  const handleGenerateCre = async () => {
    try {
      if (parseInt(qtdCarteiraItens) > 0) {
        if (itensCheckados.length === 0) {
          showModal({
            hideButtonCancel: true,
            message: 'Nenhum contrato selecionado em tela, verifique!',
            txtButtonConfirm: 'Fechar',
            type: 'alert'
          })
          return
        }
      }

      const carteiraItensInclude = itensCheckados.map((item) => ({
        idMovimentacao: item,
        idUsuario: user.IdUsuario
      }))

      const requestQuery: ICriarSimulacao = {
        carteiraItensInclude: carteiraItensInclude,
        dataAtual: new Date().toISOString(),
        nuAlerta: nuAlerta || '',
        nuDenuncia: nuDenuncia || '',
        nuPrimeiraMobilizacao: nuPrimeiraMobilizacao || '',
        nuProjeto: nuProjeto || '',
        nuQtEfetivo: nuQtEfetivo || '',
        nuUltimaAnalise: nuUltimaAnalise || '',
        nuUltimaMedicao: nuUltimaMedicao || '',
        nuValorFolha: nuValorFolha || '',
        paginacao: false,
        pesquisaGeral: pesquisaGeral || '',
        qtdCarteiraItens:
          parseInt(qtdCarteiraItens) > 0 ? parseInt(qtdCarteiraItens) : 0,
        searchQuery: ''
      }

      setLoading('loading')
      const response = await GenerateCreServices().createCarteira(requestQuery)

      if (response.status !== 200 || !response.data.sucesso) {
        throw new Error(response.data.mensagem)
      }

      showModal({
        hideButtonCancel: true,
        message: 'Carteira foi gerada com sucesso!',
        txtButtonConfirm: 'Fechar',
        type: 'success'
      })

      setQtdCarteiraItens('')
      setOldQtdCarteiraItens('')
      handleCreateSimulation({
        posGerarCarteira: true,
        simulacao: 'simulacao'
      })

      setLoading('idle')
    } catch (error: any) {
      setLoading('idle')

      showModal({
        hideButtonCancel: true,
        message: error.message ?? 'Erro ao gerar carteira',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
    }
  }

  const handleSearchCre = () => {
    setContractsIncluded([])
    setContractsExcluded([])
    handleCreateSimulation({
      paginacao: false,
      psqsGeral: true,
      simulacao: 'simulacao'
    })
    setOldQtdCarteiraItens('0')
  }

  const handlePesquisaGeral = () => {
    setContractsIncluded([])
    setContractsExcluded([])

    if (page == 1) {
      handleCreateSimulation({
        paginacao: false,
        psqsGeral: true,
        simulacao: ''
      })
    }

    setPage(1)
  }

  const setPriorityStates = () => {
    ordemPrioridades.map((prioridade, index) => {
      if (prioridade === '1ª Mobilização') {
        setNuPrimeiraMobilizacao((index + 1).toString())
      }
      if (prioridade === 'Última Mobilização') {
        setNuUltimaMedicao((index + 1).toString())
      }
      if (prioridade === 'Denúncia') {
        setNuDenuncia((index + 1).toString())
      }
      if (prioridade === 'Projeto') {
        setNuProjeto((index + 1).toString())
      }
      if (prioridade === 'Alerta') {
        setNuAlerta((index + 1).toString())
      }
      if (prioridade === 'Últ. Análise') {
        setNuUltimaAnalise((index + 1).toString())
      }
      if (prioridade === 'Valor Folha') {
        setNuValorFolha((index + 1).toString())
      }
      if (prioridade === 'Qtd. Efetivos') {
        setNuQtEfetivo((index + 1).toString())
      }
    })
    setOrdemPrioridades(ordemPrioridades)
  }

  const verifyPriorityStates = () => {
    if (!ordemPrioridades.includes('1ª Mobilização')) {
      setNuPrimeiraMobilizacao(null)
    }
    if (!ordemPrioridades.includes('Última Mobilização')) {
      setNuUltimaMedicao(null)
    }
    if (!ordemPrioridades.includes('Denúncia')) {
      setNuDenuncia(null)
    }
    if (!ordemPrioridades.includes('Projeto')) {
      setNuProjeto(null)
    }
    if (!ordemPrioridades.includes('Alerta')) {
      setNuAlerta(null)
    }
    if (!ordemPrioridades.includes('Últ. Análise')) {
      setNuUltimaAnalise(null)
    }
    if (!ordemPrioridades.includes('Valor Folha')) {
      setNuValorFolha(null)
    }
    if (!ordemPrioridades.includes('Qtd. Efetivos')) {
      setNuQtEfetivo(null)
    }
  }

  const handleCreateSimulation = async (param: ICreateSimulationParams) => {
    setLoading('loading')

    const simular = param.simulacao === 'simulacao' ? true : false

    // param.isClear = false

    try {
      const requestQUERY: ICriarSimulacao = {
        checkAll: checkAll,
        dataAtual: new Date(),
        nuAlerta: param.isClear ? null : nuAlerta,
        nuDenuncia: param.isClear ? null : nuDenuncia,
        nuPrimeiraMobilizacao: param.isClear ? null : nuPrimeiraMobilizacao,
        nuProjeto: param.isClear ? null : nuProjeto,
        nuQtEfetivo: param.isClear ? null : nuQtEfetivo,
        nuUltimaAnalise: param.isClear ? null : nuUltimaAnalise,
        nuUltimaMedicao: param.isClear ? null : nuUltimaMedicao,
        nuValorFolha: param.isClear ? null : nuValorFolha,
        pageNumber: page,
        pageSize: rowsPerPage,
        paginacao: param.paginacao || false,
        qtdCarteiraItens: param.psqsGeral
          ? parseInt(qtdCarteiraItens) || 0
          : parseInt(qtdOldCarteiraItens) >= 0 && simular === false
            ? parseInt(qtdOldCarteiraItens)
            : parseInt(qtdCarteiraItens) > 0
              ? parseInt(qtdCarteiraItens)
              : 0,
        searchQuery: param.psqsGeral ? pesquisaGeral : null,
        simulacao: simular
      }

      if (param.posGerarCarteira) requestQUERY['qtdCarteiraItens'] = 0

      // verifica se teve algum filtro alterado, se tiver ele não aplica a alteração e realiza a paginação
      if (!param.paginacao) {
        setOldRequestQuery(requestQUERY)
      } else {
        requestQUERY['nuAlerta'] = oldRequestQuery['nuAlerta']
        requestQUERY['nuDenuncia'] = oldRequestQuery['nuDenuncia']
        requestQUERY['nuPrimeiraMobilizacao'] =
          oldRequestQuery['nuPrimeiraMobilizacao']
        requestQUERY['nuProjeto'] = oldRequestQuery['nuProjeto']
        requestQUERY['nuQtEfetivo'] = oldRequestQuery['nuQtEfetivo']
        requestQUERY['nuUltimaAnalise'] = oldRequestQuery['nuUltimaAnalise']
        requestQUERY['nuUltimaMedicao'] = oldRequestQuery['nuUltimaMedicao']
        requestQUERY['nuValorFolha'] = oldRequestQuery['nuValorFolha']
      }

      const response = await GenerateCreServices().getCriarSimulacao(
        requestQUERY
      )

      if (response.status !== 200) throw new Error(response.statusText)

      if (!response.data.sucesso) throw new Error(response.data.mensagem)

      if (simular && !param.paginacao) {
        setOldQtdCarteiraItens(qtdCarteiraItens)
      }

      setCompetenciaConsolidada(response?.data?.entity?.flCompetenciaConsolidada ?? true)

      setCreTableData(response.data.entity.gridItens.items)

      setTotalItems(response.data.entity.gridItens.pageCount)
      setExistingWallet(response.data.tipo)
      setOrdenacaoList(response.data.entity.ordenacao)
      if (response.data.tipo === 'checklist')
        setQtdCarteiraItens(response.data.entity.qtCarteiraItens)

      if (param.simulacao === 'simulacao') {
        const idsResponse = response.data.entity.movimentacoesIds
        if (parseInt(qtdCarteiraItens) > 0 && !param.posGerarCarteira) {
          setItensCheckados(idsResponse)
        } else {
          setItensCheckados([])
        }
      } else if (param.limparLista) {
        setItensCheckados([])
      } else {
        // Pulando array de Id selecionados, com retorno da API
        const idsResponse = response.data.entity.movimentacoesIds
        idsResponse.forEach((element) => {
          itensCheckados.push(element)
        })
        setItensCheckados(itensCheckados.filter((i) => i))
      }

      setLoading('idle')
    } catch (error: any) {
      setMsgErro(
        error.mensagem || error.message || 'Não foi possível obter dados.'
      )
      setLoading('error')
    }
  }

  useEffect(() => {
    if (limpar) {
      handleCreateSimulation({
        isClear: true,
        simulacao: 'simulacao'
      })
      setOldQtdCarteiraItens('0')
      setLimpar(!limpar)
    }
  }, [limpar])

  useEffect(() => {
    setPriorityStates()
    verifyPriorityStates()
  }, [ordemPrioridades])

  useEffect(() => {
    if (existingWallet === 'checklist') {
      const arr = []
      ordenacaoList.forEach((ordenacao, index) => {
        if (ordenacao === 'FlPrimeiraMob') arr.push('1ª Mobilização')
        else if (ordenacao === 'FlUltMedicao') arr.push('Última Mobilização')
        else if (ordenacao === 'FlDenuncia') arr.push('Denúncia')
        else if (ordenacao === 'FlProjeto') arr.push('Projeto')
        else if (ordenacao === 'FlAlerta') arr.push('Alerta')
        else if (ordenacao === 'DtUltAnaliseCRE') arr.push('Últ. Análise')
        else if (ordenacao === 'VlFolhaPagto') arr.push('Valor Folha')
        else if (ordenacao === 'QtTotalEfetivo') arr.push('Qtd. Efetivos')
      })
      setOrdemPrioridades(arr)
    }
  }, [ordenacaoList])

  useEffect(() => {
    if (unCheckAll) {
      creTableData.forEach((item) => {
        item.checked = false
      })
      setUncheckAll(false)
    } else {
      creTableData.forEach((item) => {
        if (item.movimentacaoId) {
          if (itensCheckados.includes(item.movimentacaoId)) {
            item.checked = true
          } else {
            item.checked = false
          }
        }
      })
    }
  }, [creTableData, itensCheckados])

  useEffect(() => {
    handleCreateSimulation({
      paginacao: true,
      psqsGeral: true
    })
  }, [rowsPerPage, page])

  useEffect(() => {
    // Realizando a remoção da lista dos itens selecionados
    itensCheckados.forEach((item) => {
      const index = itensCheckados.indexOf(item)
      itensCheckados.splice(index)
    })

    handleCreateSimulation({
      paginacao: false,
      psqsGeral: true
    })
  }, [checkAll])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <GenerateCreForm
          qtdCarteiraItens={qtdCarteiraItens}
          pesquisaGeral={pesquisaGeral}
          ordemPrioridades={ordemPrioridades}
          handleChangeQtdCarteira={handleChangeQtdCarteira}
          handleChangePesqisaGeral={handleChangePesqisaGeral}
          handleChangeOrdemPrioridades={handleChangeOrdemPrioridades}
          handleSearchCre={handleSearchCre}
          handleClearButton={handleClearButton}
          existingWallet={existingWallet}
          handlePesquisaGeral={handlePesquisaGeral}
        />
        <TableGenerateCre
          tableData={creTableData}
          handleContractSelection={handleContractSelection}
          totalItems={totalItems}
          page={page}
          checkPages={checkAll}
          setCheckPages={setCheckAll}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          handleGenerateCre={handleGenerateCre}
          selectedContractInfo={handleViewContractModal}
          clearCheckAll={clearCheckAll}
          setClearCheckAll={setClearCheckAll}
          existingWallet={existingWallet}
          handleIncludeCre={handleIncludeCre}
        />
      </Card>
      <ViewContractModal
        showModal={openViewContractModal}
        toggleModal={toggleViewContractModal}
        contractID={selectedContractId}
      />
    </>
  )
}

export default GenerateCre
